import { cloneDeep } from "lodash";

import { ChartSettings } from "@/classes/BaseChart/index";
import Lang from "@/lang";
import { otherValues } from "@/settings/constants";

class ChartWithOther {
  declare settings: ChartSettings;

  protected showItems<T extends Record<string, unknown>>(
    paramData: T[],
    visualField: string,
    metric: string | undefined,
    positionOther?: "first"
  ): T[] {
    if (!this.settings.showItems || !paramData.length) {
      return paramData;
    }
    const data = cloneDeep(paramData);
    const index = data.findIndex((el) => {
      return otherValues.includes(el[visualField] as string);
    });
    if (index === -1) {
      return data;
    }
    const [other] = data.splice(index, 1) as Record<string, unknown>[];
    if (metric === undefined || other[metric]) {
      other[visualField] = Lang.other;
      positionOther === "first" ? data.unshift(other as T) : data.push(other as T);
    }

    return data;
  }
}

export default ChartWithOther;
